import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import PropTypes from "prop-types";
import React from "react";

import MiniPage from "../MiniPage";
import styles from "../../styles/components/TogglePageCard.css";

/**
 * A `MiniPage` that can be toggled on or off with an icon to indicate its current state.
 * @param onToggleSelected called when the component is clicked.
 * @param isSelected whether the page is currently selected (i.e., toggled "on").
 * @param miniPageProps props to pass through to the `MiniPage` component.
 * @returns {*}
 * @constructor
 */
export default function TogglePageCard({
    onToggleSelected,
    isSelected,
    ...miniPageProps
}) {
    return (
        <div className={styles.togglePageCard} onClick={onToggleSelected}>
            <div className={styles.iconBar}>
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={isSelected ? faEye : faEyeSlash}
                    size="lg"
                />
            </div>
            <MiniPage {...miniPageProps} />
        </div>
    );
}

TogglePageCard.propTypes = {
    onToggleSelected: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    ...MiniPage.propTypes
};



// WEBPACK FOOTER //
// ./src/components/Results/TogglePageCard.js